export const FETCH_TASKS = 'FETCH_TASKS';
export const FETCH_OFF_PLAN_TERMINATION_TASK_LIST = 'FETCH_OFF_PLAN_TERMINATION_TASK_LIST';
export const FETCH_OFF_PLAN_TERMINATION_TASK_LIST_SUCCESS = 'FETCH_OFF_PLAN_TERMINATION_TASK_LIST_SUCCESS';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
export const FETCH_TASKS_FOR_NAVBAR_COMPONENT_SUCCESS = 'FETCH_TASKS_FOR_NAVBAR_COMPONENT_SUCCESS';
export const FETCH_TASKS_ERROR = 'FETCH_TASKS_ERROR';
